import { AppModule } from '@/store/modules/app';

// Counters as the portal shows them: 12.443 (German grouping), 12,443 in English
export const formatCount = (count: number): string => new Intl.NumberFormat(AppModule.language === 'en' ? 'en' : 'de').format(count);
